import { render } from "./left-menu-button.vue?vue&type=template&id=2696bd2c"
import script from "./left-menu-button.vue?vue&type=script&lang=js"
export * from "./left-menu-button.vue?vue&type=script&lang=js"
script.render = render

export default script